import { Component, OnInit } from '@angular/core';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-config-guide',
    templateUrl: './config-guide.component.html',
    styleUrls: ['./config-guide.component.css'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent]
})
export class ConfigGuideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
